import ReportDom from "../../../../../components/common/ReportDom";
import PurchaseOrderVoucherBody from "./PurchaseOrderVoucherBody";

export default function PurchaseOrderPrint({ id }) {
  return (
    <ReportDom
      renderTable={() => <PurchaseOrderVoucherBody pur_o_id={id} printMode />}
    />
  );
}
